exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#widget[data-v-4a359d5a]{min-height:450px;position:relative}.loader[data-v-4a359d5a]{border:8px solid #f3f3f3;border-top:8px solid #05bdbd;border-radius:50%;width:120px;height:120px;animation:spin-data-v-4a359d5a 1.4s linear infinite}@keyframes spin-data-v-4a359d5a{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a359d5a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 494
// module chunks = 0